import React from 'react';
import ConstructionOutlinedIcon from '@mui/icons-material/ConstructionOutlined';
import PageContainer from '../PageContainer';
import PortalEmptyState from '../layout/PortalEmptyState';

const PartnerPlaceholderPage = ({ title }) => (
  <PageContainer title={title}>
    <PortalEmptyState
      icon={ConstructionOutlinedIcon}
      title={`${title} is coming soon`}
      description="This section is under development. Check back in a future release for updates."
      compact
    />
  </PageContainer>
);

export default PartnerPlaceholderPage;
